export function MainBody({ children }: { children: JSX.Element }) {
  return (
    <div className="w-full min-h-screen flex bg-white p-2">
      {children}
    </div>
  )
}